module.exports = __webpack_public_path__ + "img/8_h_no.571b2a0d.svg";